import axios from 'api/axios'
import handleAxiosError from 'utils/handleAxiosError'
import { CreateSubscriptionBody, SubscriptionResponse } from 'types'

export const createNewSubscription = async (body: CreateSubscriptionBody) => {
	try {
		const { data } = await axios.post<SubscriptionResponse>(
			'/v1/plan/subscriptions',
			body
		)
		return data
	} catch (error: any) {
		handleAxiosError(error)
		throw error
	}
}

export default createNewSubscription
